
import React from 'react';
import { Button } from '@/components/ui/button';
import { 
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { 
  Archive, 
  Copy as CloneIcon, 
  MoreHorizontal, 
  FileCheck as PreviewIcon, 
  UserPlus, 
  Trash2
} from 'lucide-react';

interface SettingsActionsProps {
  onButtonClick: (e: React.MouseEvent) => void;
  onDeleteClick: () => void;
}

export function SettingsActions({ onButtonClick, onDeleteClick }: SettingsActionsProps) {
  return (
    <div className="flex items-center gap-2">
      <Button variant="outline" onClick={onButtonClick} className="gap-2">
        <Archive className="h-4 w-4" />
        Archive
      </Button>
      <Button variant="outline" onClick={onButtonClick} className="gap-2">
        <CloneIcon className="h-4 w-4" />
        Clone
      </Button>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" onClick={(e) => e.preventDefault()}>
            <MoreHorizontal className="h-4 w-4" />
            More
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-[200px]">
          <DropdownMenuItem onClick={(e) => e.preventDefault()}>
            <PreviewIcon className="mr-2 h-4 w-4" />
            Preview
          </DropdownMenuItem>
          <DropdownMenuItem onClick={(e) => e.preventDefault()}>
            <UserPlus className="mr-2 h-4 w-4" />
            Invite Candidates
          </DropdownMenuItem>
          <DropdownMenuItem 
            className="text-destructive" 
            onClick={(e) => {
              e.preventDefault();
              onDeleteClick();
            }}
          >
            <Trash2 className="mr-2 h-4 w-4" />
            Delete
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
